import firedux from '../firedux'
import {dispatch} from '../store'

import {
  CONVERSATION_MESSAGE_COUNTS_ENDPOINT,
  CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT
} from '../../config/constants'

import setTotalMessageCount from '../actions/set_total_message_count'
import setReadMessageCount from '../actions/set_read_message_count'

const initReadMessageCount = (uid, containerId) => {
  const readRef = firedux.ref.child(CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId)
  const totalRef = firedux.ref.child(CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId)

  Promise.all([
    readRef.once('value'), totalRef.once('value')
  ])
  .then(([readSnap, totalSnap]) => {
    if (readSnap.exists()) return Promise.resolve()
    if (!totalSnap.exists()) return Promise.resolve()

    return readRef.set(totalSnap.val())
  })
}

const onTotalMessageCount = (snapshot) => {
  dispatch(setTotalMessageCount(snapshot.val() || 0, snapshot.key()))
}

const onReadMessageCount = (snapshot) => {
  dispatch(setReadMessageCount(snapshot.val() || 0, snapshot.key()))
}

export const watchTotalMessageCount = (containerId) => {
  const ref = firedux.ref.child(CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId)

  ref.on('value', onTotalMessageCount)
}

export const unwatchTotalMessageCount = (containerId) => {
  const ref = firedux.ref.child(CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId)

  ref.off('value', onTotalMessageCount)
}

export const watchReadMessageCount = (uid, containerId) => {
  const ref = firedux.ref.child(CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId)

  initReadMessageCount(uid, containerId)

  ref.on('value', onReadMessageCount)
}

export const unwatchReadMessageCount = (uid, containerId) => {
  const ref = firedux.ref.child(CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId)

  ref.off('value', onReadMessageCount)
}

export const watchMessageCounts = (uid, containerId) => {
  watchReadMessageCount(uid, containerId)
  watchTotalMessageCount(containerId)
}

export const unwatchMessageCounts = (uid, containerId) => {
  unwatchReadMessageCount(uid, containerId)
  unwatchTotalMessageCount(containerId)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/message_counts.js
 **/